<template>
  <spinner v-if="$apollo.loading" />
  <div v-else>
    <h1 class="title-screen">Documentation</h1>
    <div class="document-wrapper">
      <div class="document-container full-width">
        <div class="document-header">
          <img alt="Summary" src="/assets/file.svg">
          <p style="margin-bottom: 0" class="document-type">Summary</p>
        </div>
        <div class="inputs-container">
          <v-autocomplete
            v-model="selectedPerformance"
            :items="performances"
            :label="'Performances'"
            item-text="eventDate"
            return-object
            box
            :disabled="!performances.length"
            @change="val => handlePerformanceSelect(val)"
          />
          <div style="display: flex; gap: 1rem">
            <date-field
              v-if="eventCreatedAt"
              v-model="summaryFrom"
              style="flex: 1"
              label="From date"
              :max="summaryTo ? summaryTo.toString() : (eventTo || null).toString()"
              :min="eventCreatedAt.toString()"
            />
            <date-field
              v-if="eventCreatedAt"
              v-model="summaryTo"
              style="flex: 1"
              label="To date"
              :max="eventTo.toString()"
              :min="summaryFrom ? summaryFrom.toString() : null"
            />
          </div>
        </div>
        <a :href="getUrl" target="_blank" style="padding: 16px; align-self: flex-end">
          <main-button flat>Generate</main-button>
        </a>
      </div>

      <div class="document-container full-width" :class="{ disabled: !legalInvoicesAvailable }">
        <div class="document-header">
          <img alt="Summary" src="/assets/file.svg">
          <p style="margin-bottom: 0" class="document-type">R1 Invoices</p>
        </div>
        <div v-if="legalInvoicesAvailable" class="document-actions">
          <div>
            <span> Invoice count: </span>
            <span class="invoice-number">
              {{ legalInvoicesAvailable }}
            </span>
          </div>
          <router-link
            :to="{
              name: routes.theaterOrganizer.eventLegalEntityInvoicesTheater,
              params: {
                organizationSlug: organizationSlug,
                eventId: selectedPerformance.id,
                eventTemplateId: eventTemplateId,
              },
            }"
          >
            <main-button flat>Open</main-button>
          </router-link>
        </div>

        <div v-else class="not-available">Not available</div>
      </div>
    </div>
  </div>
</template>
<script>
import { frontendURL } from '@/utils'
import { GET_ALL_PERFORMANCES_BT_EVENT_TEMPLATE_ID } from '@/graphql/event.graphql'
import { GET_EVENT_INVOICES_CATEGORIZED } from '../../graphql/purchase.graphql'
import moment from 'moment'

export default {
  name: 'theater-documentation-container',
  props: {
    organizationSlug: {
      type: String,
      default: '',
    },
    eventTemplateId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      summaryFrom: undefined,
      summaryTo: undefined,
      eventCreatedAt: null,
      eventTo: null,
      selectedPerformance: null,
      performances: null,
      legalInvoicesAvailable: false,
    }
  },
  computed: {
    getUrl() {
      return `${frontendURL}/organizations/${this.organizationSlug}/events/${
        this.selectedPerformance && this.selectedPerformance.id
      }/summary${
        this.summaryFrom && this.summaryTo
          ? `?from=${this.fullFromDate()}&to=${this.fullToDate()}`
          : ''
      }`
    },
  },
  methods: {
    async getR1InvoicesForSelectedPerformance(eventId) {
      const { data } = await this.$apollo.query({
        query: GET_EVENT_INVOICES_CATEGORIZED,
        variables: {
          eventId: eventId,
        },
      })
      const { invoicesCategorized } = data.getEventInvoicesCountCategorized

      this.legalInvoicesAvailable = invoicesCategorized.legalEntityInvoicesCount
    },
    async handlePerformanceSelect(performance) {
      await this.getR1InvoicesForSelectedPerformance(performance.id)
      this.eventTo = performance.to
      this.eventCreatedAt = performance.createdAt
    },
    fullFromDate() {
      if (this.summaryFrom) {
        const date = new Date(this.summaryFrom)
        date.setHours(0, 0, 0, 0) // Set time to 00:00:00

        return date
      }

      return undefined
    },
    fullToDate() {
      if (this.summaryTo) {
        const date = new Date(this.summaryTo)
        date.setHours(22, 59, 59, 999) // Set time to 22:59:59.999

        return date
      }

      return undefined
    },
  },
  apollo: {
    getAllPerformancesByEventTemplateId: {
      query: GET_ALL_PERFORMANCES_BT_EVENT_TEMPLATE_ID,
      variables() {
        return {
          eventTemplateId: this.eventTemplateId,
        }
      },
      manual: true,
      result({ data, loading }) {
        if (!loading && data) {
          this.performances = data.getAllPerformancesByEventTemplateId.map(p => {
            return {
              ...p,
              eventDate: moment(p.from).format('DD.MM.YYYY [at] HH:mm'),
            }
          })
        }
      },
    },
  },
}
</script>
<style scoped>
.document-wrapper {
  display: grid;
  grid-auto-flow: row;
  gap: 2rem;
}

.inputs-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  padding: 1.5rem;
}

.date-container div {
  flex: 1;
}

.document-container {
  display: flex;
  width: 100%;
  max-width: 685px;
  flex-direction: column;
  border-radius: 16px;
  border: 2px solid #d9d9d9;
  align-items: flex-start;
  flex-shrink: 0;
}

.document-container.disabled {
  pointer-events: none;
  color: #979797;
}

@media screen and (min-width: 1024px) {
  .date-container {
    flex-direction: row;
  }

  .document-container {
    width: 335px;
  }

  .document-container.full-width {
    width: 100%;
  }
}

.document-header {
  border-radius: 16px 16px 0 0;
  display: flex;
  width: 100%;
  padding: 24px;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  background: #f5f5f5;
  gap: 1rem;
}

.document-type {
  color: #666;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.72px;
}

.document-actions {
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.document-actions > div {
  font-size: 20px;
  font-weight: 400;
  color: #666666;
}

.document-actions .invoice-number {
  color: #0277bd;
  font-size: 18px;
  font-weight: 700;
  padding: 0 0.5rem;
  margin-left: 8px;
  background-color: #f0f6fa;
}

.document-container .not-available {
  padding: 24px;
  align-self: flex-start;
}
</style>
